import { render, staticRenderFns } from "./EmojiBtn.vue?vue&type=template&id=23cac01e&scoped=true&"
import script from "./EmojiBtn.vue?vue&type=script&lang=js&"
export * from "./EmojiBtn.vue?vue&type=script&lang=js&"
import style0 from "./EmojiBtn.vue?vue&type=style&index=0&id=23cac01e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cac01e",
  null
  
)

export default component.exports